// @flow
import React from "react";
import {Table, Tooltip} from "antd";
import moment from "moment";
import {useTranslation} from "react-i18next";
import {EmptyMessage} from "../../_defaultComponents/EmptyMessage/EmptyMessage";
import {isArray} from "lodash";
import {
    activationSteps,
    activationSubSteps,
    personalCompanySetupStatus,
    courierStatusLogTypes
} from "constants/constants";
import {isConstantExist, getConstant} from "utils/helpers";
import { StyledTable } from "./courierOnboardingTab/courierSummary/courierEquipmentInformations/CourierEquipmentInformations.styled";
import {RiSparklingFill} from "react-icons/ri";

const {Column} = Table;

export const CourierStatusLogTable = ({loading, data, onChange}) => {
    const {t, i18n} = useTranslation(["courierStatusLogTable"]);
    const logs = data?.logs ? data.logs : isArray(data) ? data : [];

    const handleTableChange = pagination => {
        if (onChange) {
            const page = pagination.current;
            const skip = (page - 1) * pagination.pageSize;
            onChange({
                skip,
                limit: pagination.pageSize,
                page
            });
        }
    };

    return (
        <StyledTable
            loading={loading}
            dataSource={logs}
            rowKey="_id"
            data-testid="logTable"
            locale={{emptyText: <EmptyMessage />}}
            onChange={handleTableChange}
            pagination={{
                pageSize: 10,
                total: data?.dataCount || 0,
                showSizeChanger: false
            }}
        >
            <Column
                title={t("fields.date", {ns: "common"})}
                dataIndex="createdAt"
                sorter={(a, b) => moment(a.createdAt).unix() - moment(b.createdAt).unix()}
                onCell={() => ({
                    "data-label": t("fields.date", {ns: "common"})
                })}
                render={text => (
                    <span data-testid="createdAt">
                        {moment(text)
                            .locale(i18n.resolvedLanguage || "tr")
                            .format("lll")}
                    </span>
                )}
            />
            <Column
                title={t("fields.type", {ns: "courierStatusLogTable"})}
                dataIndex="type"
                onCell={() => ({
                    "data-label": t("fields.type", {ns: "courierStatusLogTable"})
                })}
                render={text => (
                    <span data-testid="type">
                        {isConstantExist(courierStatusLogTypes, text)
                            ? t(getConstant(courierStatusLogTypes, text).translation_key, {
                                  ns: "courierStatusLogTypes"
                              })
                            : "-"}
                    </span>
                )}
            />
            <Column
                title={t("fields.activationStatus", {ns: "courierStatusLogTable"})}
                dataIndex={["status", "disabled"]}
                onCell={() => ({
                    "data-label": t("fields.activationStatus", {ns: "courierStatusLogTable"})
                })}
                render={text => <span data-testid="disabled">{text ? "Pasif" : "Aktif"}</span>}
            />
            <Column
                title={t("fields.activationStep", {ns: "courierStatusLogTable"})}
                dataIndex={["status", "activationStep"]}
                onCell={() => ({
                    "data-label": t("fields.activationStep", {ns: "courierStatusLogTable"})
                })}
                render={text => (
                    <span data-testid="activationStep">
                        {isConstantExist(activationSteps, text)
                            ? t(getConstant(activationSteps, text).translation_key, {
                                  ns: "activationSteps"
                              })
                            : "-"}
                    </span>
                )}
            />
            <Column
                title={t("fields.activationSubStep", {ns: "courierStatusLogTable"})}
                dataIndex={["status", "activationSubStep"]}
                onCell={() => ({
                    "data-label": t("fields.activationSubStep", {ns: "courierStatusLogTable"})
                })}
                render={text => (
                    <span data-testid="activationSubStep">
                        {isConstantExist(activationSubSteps, text)
                            ? t(getConstant(activationSubSteps, text).translation_key, {
                                  ns: "activationSubSteps"
                              })
                            : "-"}
                    </span>
                )}
            />
            <Column
                title={t("fields.reason", {ns: "courierStatusLogTable"})}
                dataIndex={["status", "reasonNote"]}
                onCell={() => ({
                    "data-label": t("fields.reason", {ns: "courierStatusLogTable"})
                })}
                render={text => (
                    <span data-testid="reason">
                        {isConstantExist(personalCompanySetupStatus, text)
                            ? t(getConstant(personalCompanySetupStatus, text).translation_key, {
                                  ns: "personalCompanySetupStatus"
                              })
                            : text || "-"}
                    </span>
                )}
            />
            <Column
                title={t("fields.updatedBy", {ns: "courierStatusLogTable"})}
                dataIndex={["user", "fullName"]}
                onCell={() => ({
                    "data-label": t("fields.updatedBy", {ns: "courierStatusLogTable"})
                })}
                render={(text, record) => {
                    const userType = record?.user?.userType;
                    const displayName = text
                        ? userType === "courier"
                            ? `${text} (Başvuran Kişi)`
                            : text
                        : "-";
                    return (
                        <Tooltip
                            title={
                                record?.processedByAutomation
                                    ? `Otomasyon tarafından işlem yapılmıştır.`
                                    : displayName
                            }
                        >
                            <span
                                data-testid="fullName"
                                style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    gap: "4px"
                                }}
                            >
                                {displayName}
                                {record?.processedByAutomation ? <RiSparklingFill /> : <></>}
                            </span>
                        </Tooltip>
                    );
                }}
            />
        </StyledTable>
    );
};
